import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import SiteHeader from "@/components/shop/SiteHeader";
import SiteFooter from "@/components/shop/SiteFooter";
import CartDrawer from "@/components/shop/CartDrawer";

export default function CheckoutCancel() {
  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid="checkout-cancel-page">
      <SiteHeader />
      <CartDrawer />
      <section className="mx-auto max-w-xl px-5 sm:px-8 py-24 text-center">
        <div className="mx-auto w-20 h-20 rounded-full bg-amber-50 flex items-center justify-center">
          <XCircle size={44} className="text-amber-500" />
        </div>
        <h1 className="mt-6 font-display text-4xl font-black text-[#0f2a5c]">Checkout canceled</h1>
        <p className="mt-3 text-slate-600">No problem — your cart is safe and waiting for you.</p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/cart" className="px-6 py-3 rounded-full bg-[#173a7a] text-white font-semibold hover:bg-[#1a4694]">
            Return to Cart
          </Link>
          <Link to="/shop" className="px-6 py-3 rounded-full bg-slate-100 text-slate-700 font-semibold hover:bg-slate-200">
            Keep Shopping
          </Link>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
